import { GetProjectTreeProjectChildNode } from 'src/model/api/get-project-tree-project-childnode.model';

export function getFloorNameForRoom(roomId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): string {
  let floorId = getFloorIdForRoom(roomId, projectTreeNodes);
  return projectTreeNodes.find((node) => node.id === `floor_${floorId}`)!!.text!!
}

export function getFloorIdForRoom(roomId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): string {
  return projectTreeNodes.find((node) => node.id === `room_${roomId}`)!!.parent!!.replace("floor_", "")
}

export function getRoomName(roomId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): string {
  let roomNode = projectTreeNodes.find((node) => node.id === `room_${roomId}`)!!;
  return roomNode.text;
}

export function getRoomById(roomId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): GetProjectTreeProjectChildNode {
  let roomNode = projectTreeNodes.find((node) => node.id === `room_${roomId}`)!!;
  return roomNode;
}

export function getFloorNameForFloor(floorId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): string {
  let floorNode = projectTreeNodes.find((node) => node.id === `floor_${floorId}`)!!;
  return floorNode.text;
}

export function getJustUnnasigned(floorId: number, projectTreeNodes: GetProjectTreeProjectChildNode[]): boolean {
  let floorNode = projectTreeNodes.find((node) => node.id === `floor_${floorId}`);
  return floorNode?.just_assigned_floor ? floorNode.just_assigned_floor : false;

}

export function getFloorIds(projetTreeNodes: GetProjectTreeProjectChildNode[]): number[] {
  return projetTreeNodes.filter((node) => node.type === "floor")
  .map((node)=> node.floorId!!)
}

export function getFloors(projetTreeNodes: GetProjectTreeProjectChildNode[]): GetProjectTreeProjectChildNode[] {
  return projetTreeNodes.filter((node) => node.type === "floor")
}

export function getRoomsOfFloor(floorId: number, projetTreeNodes: GetProjectTreeProjectChildNode[]): GetProjectTreeProjectChildNode[] {
  return projetTreeNodes.filter((node) => node.type === "room" && node.parent === 'floor_' + floorId);
}

